import { Component, Input, OnChanges } from '@angular/core'

import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'
import { Recebimento } from '../../../pkw-data/collect/extrato/recebimento.model'

@Component({
    selector: 'col-detalhe-extrato-de-recebimentos',
    templateUrl: './detalhe-extrato-de-recebimentos.component.html',
    styleUrls: ['./detalhe-extrato-de-recebimentos.component.scss']
})
export class DetalheExtratoDeRecebimentosComponent implements OnChanges {
    @Input() agrupamento: Agrupamento<Recebimento>

    maisDetalhesExpandido: boolean[]

    constructor() {}

    ngOnChanges() {
        if (this.agrupamento) {
            this.maisDetalhesExpandido = new Array(this.agrupamento.detalhes.length)
            this.maisDetalhesExpandido.fill(false)
        }
    }

    toggleCollapse(index: number, icon: HTMLSpanElement) {
        this.maisDetalhesExpandido[index] = !this.maisDetalhesExpandido[index]

        icon.classList.toggle('fa-chevron-right')
        icon.classList.toggle('fa-chevron-down')
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-recebimentos/detalhe-extrato-de-recebimentos/detalhe-extrato-de-recebimentos.component.ts